/* tslint:disable */
/* eslint-disable */
/**
 * Juhsis REST Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ApiCredentialRequest
 */
export interface ApiCredentialRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiCredentialRequest
     */
    'credentialType'?: ApiCredentialRequestCredentialTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ApiCredentialRequest
     */
    'value'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiCredentialRequest
     */
    'buyPercentage'?: number;
}

export const ApiCredentialRequestCredentialTypeEnum = {
    SeekingAlphaPro: 'SEEKING_ALPHA_PRO',
    SeekingAlphaPremium: 'SEEKING_ALPHA_PREMIUM',
    Trading212ApiKey: 'TRADING212_API_KEY',
    Trading212ApiSecret: 'TRADING212_API_SECRET',
    InaTrading212ApiKey: 'INA_TRADING212_API_KEY',
    InaTrading212ApiSecret: 'INA_TRADING212_API_SECRET',
    Trading212Isa: 'TRADING212_ISA',
    Trading212Cfd: 'TRADING212_CFD',
    AlphaWorkerApiKey: 'ALPHA_WORKER_API_KEY',
    PolygonApiKey: 'POLYGON_API_KEY'
} as const;

export type ApiCredentialRequestCredentialTypeEnum = typeof ApiCredentialRequestCredentialTypeEnum[keyof typeof ApiCredentialRequestCredentialTypeEnum];


